import { useMediaQuery, useTheme } from "@mui/material";
import React, { useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@components";
import { AccountAddSelection } from "./components/addChoiceBlock/AddChoiceBlock";
import { AddManuallyBlock } from "./components/addManuallyBlock/AddManuallyBlock";
import { ImportType, ImportTypeRef, ImportTypeText } from "./components/types";

const modalText: ImportTypeText = {
  "": {
    title: "accounts.add.title",
    subtitle: "accounts.add.subtitle",
  },
  bank: {
    title: "accounts.add.titleBank",
    subtitle: "accounts.add.subtitleBank",
  },
  manually: {
    title: "accounts.add.titleManual",
  },
};

interface AddModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const AddModal = ({
  ref,
  isOpen,
  setIsOpen,
}: AddModalProps & { ref?: React.Ref<ImportTypeRef> }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [importType, setImportType] = useState<ImportType>({ type: "" });
  const isLessSm = useMediaQuery(theme.breakpoints.down("sm"));

  useImperativeHandle(ref, () => ({ setImportType }));

  const closeModal = () => {
    setIsOpen(false);
    setImportType({ type: "" });
  };

  return (
    <Modal
      isOpen={isOpen}
      title={t(modalText[importType.type].title)}
      subtitle={t(modalText[importType.type]?.subtitle || "")}
      titleVariant="h4"
      subtitleVariant="body1"
      contentPadding={isLessSm ? theme.spacing(4) : theme.spacing(4, 8, 8)}
      height="auto"
      maxHeight={isLessSm ? "calc(100vh - 160px)" : "auto"}
      onClose={closeModal}
    >
      {importType.type === "" && (
        <AccountAddSelection
          onSelection={setImportType}
          importType={importType}
        />
      )}
      {importType.type === "manually" && (
        <AddManuallyBlock
          closeModal={closeModal}
          onBack={() => setImportType({ type: "" })}
          defaultType={importType.default}
        />
      )}
      {importType.type === "bank" && <></>}
    </Modal>
  );
};

export default AddModal;
